import { useEffect, useState } from 'react';
import { useMap } from '@vis.gl/react-google-maps';

type UseStreetView = {
  streetViewVisible: boolean;
};

const useStreetView = (): UseStreetView => {
  const map = useMap();
  const [streetViewVisible, setStreetViewVisible] = useState(false);

  useEffect(() => {
    if (!map) {
      return undefined;
    }

    const panorama = map.getStreetView();
    setStreetViewVisible(panorama.getVisible());

    panorama.setOptions({
      addressControlOptions: {
        position: google.maps.ControlPosition.TOP_RIGHT,
      },
    });

    const listener = panorama.addListener('visible_changed', () => {
      setStreetViewVisible(panorama.getVisible());
    });

    return () => {
      listener.remove();
      panorama.setVisible(false);
    };
  }, [map]);

  return { streetViewVisible };
};

export default useStreetView;
